import { ref, useContext } from "@nuxtjs/composition-api";
function useRecaptcha() {
  const { $recaptcha } = useContext();
  const id = Math.random().toString(36);
  const widgetId = ref();
  const isBusy = ref(false);
  const token = ref("");
  const getToken = () => {
    return token.value;
  };
  const reset = () => {
    isBusy.value = false;
    $recaptcha.reset();
  };
  const init = async () => {
    await $recaptcha.init();
    widgetId.value = $recaptcha.render(id, {
      // @ts-expect-error Incorrect types in recaptcha nuxt module
      sitekey: $recaptcha.siteKey
    });
  };
  const setToken = (t = "") => {
    token.value = t;
  };
  return {
    id,
    init,
    setToken,
    isBusy,
    getToken,
    reset
  };
}
var useRecaptcha_default = useRecaptcha;
export {
  useRecaptcha_default as default
};
